import { Address } from '../';

export class BikeAddress {
    Id: number;
    BikeId: number;
    Address: Address;
}
